exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-cv-container[data-v-4a3bef7a]{color:#363636;font-size:13px}.modal-title[data-v-4a3bef7a]{font-size:20px;font-weight:700;margin-bottom:36px}.box-check[data-v-4a3bef7a]{background-color:#f5f5f5;padding:12px;margin-top:12px;gap:12px 0;display:grid;max-height:30vh;overflow-y:auto}.is-line-grey[data-v-4a3bef7a]{width:87px;height:30px;margin-left:12px}.input-border[data-v-4a3bef7a]{border:1px solid #ccc;border-radius:4px;padding:7px;width:210px}.input-border[data-v-4a3bef7a]:focus{outline:none}", ""]);

// exports
